<template>
    <div class="patient-id" v-if="participant.id">
        <div class="patient-id__inner">

            <div class="patient-id__name">
                {{ participant.fullname }}
            </div>

            <patient-dob style="display:inline-block" class="ml-3"
                         :participant="participant"></patient-dob>

            <b-btn variant="primary" size="sm" class="px-2 ml-3 btn-onblue patient-id__btn"
                   v-if="showContactInfo"
                   id="popover-button">
                <b-icon icon="phone"></b-icon>
            </b-btn>

            <b-popover target="popover-button"
                       custom-class="patient-id__popover"
                       triggers="click"
                       placement="bottomright">
                <patient-contact-methods-display :participant="participant">
                </patient-contact-methods-display>
            </b-popover>

            <template v-if="newNotes">
                <svg v-b-popover.hover.right="$i18n.gt('TOOLTIP_NEW_NOTES')" class="notification-badge"  viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5" r="5"/>
                </svg>
            </template>
        </div>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
/**
 * Displays identifying info for the current patient
 * */
import Vue from 'vue'

export default Vue.extend({
    name: 'PatientId',
    props: {
        participant: Object,
        showContactInfo: Boolean
    },
    computed: {
        newNotes() {
            return ((this.participant.notes_edited > this.participant.notes_viewed_by_provider) || this.participant.notes_edited && !this.participant.notes_viewed_by_provider) && this.participant.allowProviderView
        },
    }
})
</script>

<!-- ----------------------------------------------------------------------- -->


<style lang="scss">

.patient-id {
    position: relative;
    display: inline-block;
    color: #fff;
    font-size: 15px;
    background-color: var(--green-darken-5);
    padding: 4px;

    label {
        color: #fff;
    }

    .badge {
        background-color: #fff;
        color: var(--green-darken-15);
        border-radius: 3px;
        font-size: 15px;
        padding: 4px 8px;
    }

    //border: solid 2px var(--secondary);
    border-radius: 2px;

    .notification-badge {
        fill: var(--red);
        width: 15px;
        height: 15px;
        position: absolute;
        right: -5px;
        top: -5px;
    }
}

.patient-id__inner {
    padding: 5px 15px;
}

.patient-id__name {
    display: inline-block;
    font-weight: bold;
}

.popover.patient-id__popover {
    font-size: 15px;

    label {
        font-size: 12px;
    }
}

.patient-id__contact {
    letter-spacing: 1.25px;
    margin-left: 5px;
    font-weight: bold;
}

.patient-id__contact__yes {
    color: var(--green);
}

.patient-id__contact__no {
    color: var(--red);
}

</style>
